import {
  CheckContent
} from "./chunk-I6N6IZPN.mjs";
import {
  CheckDescMeta
} from "./chunk-WXSOZZRZ.mjs";
import {
  CheckTitle
} from "./chunk-TBX2S6DG.mjs";

// src/checker/calculation.ts
var Calculation = ({ keyword, title, descriptionMeta }, domDocument, t) => {
  const contentScore = new CheckContent(domDocument, keyword, t);
  const descMetaScore = new CheckDescMeta(descriptionMeta, keyword, t);
  const titleScore = new CheckTitle(title, keyword, t);
  const seoScore = contentScore.countScore(75) + titleScore.countScore(20) + descMetaScore.countScore(5);
  return {
    seoScore,
    sectionScore: [
      contentScore.getResult(),
      descMetaScore.getResult(),
      titleScore.getResult()
    ]
  };
};
var calculation_default = Calculation;

export {
  calculation_default
};
